import { Controller } from "@hotwired/stimulus";

// Shows/hides a block of content from an icon toggle button whose label lives
// in its tooltip and aria-label.
//
//   <div data-controller="disclosure"
//        data-disclosure-show-label-value="Show students"
//        data-disclosure-hide-label-value="Hide students">
//     <button type="button" aria-expanded="false" aria-label="Show students"
//             title="Show students" data-toggle="tooltip"
//             data-disclosure-target="button" data-action="disclosure#toggle">…icon…</button>
//     <div data-disclosure-target="content" hidden>…</div>
//   </div>
export default class extends Controller {
  static targets = ["button", "content"];
  static values = { showLabel: String, hideLabel: String };

  toggle() {
    const expanded = this.contentTarget.hidden;
    const label = expanded ? this.hideLabelValue : this.showLabelValue;

    this.contentTarget.hidden = !expanded;
    this.buttonTarget.setAttribute("aria-expanded", String(expanded));
    this.buttonTarget.setAttribute("aria-label", label);
    this.buttonTarget.setAttribute("title", label);
    // Bootstrap 3 tooltips read their text from data-original-title once initialized.
    this.buttonTarget.setAttribute("data-original-title", label);

    const $button = window.jQuery && window.jQuery(this.buttonTarget);
    if ($button && $button.tooltip) $button.tooltip("hide");
  }
}
